<template>
  <div class="container container--large">
    <section class="section-web section-web--alt">
      <div
        class="section__actions d-flex justify-content-between align-items-center flex-wrap"
      >
        <p>My Organization's Information:</p>
      </div>
      <!-- /.section__actions -->

      <div
        class="section__content section__content--grey"
        v-bind:class="{ 'mobile-wrap ': isMobile }"
      >
        <!-- {{organization}} -->
        <!-- {{organization.sFrontpage}} -->
        <!-- style="-webkit-transform:scale(0.5);-moz-transform-scale(0.5);" -->
        <div v-html="organization[0].sFrontpage"></div>

        <!-- /.large mt-2 -->
      </div>
      <div
        class="section__actions align-items-right flex-wrap"
        style="text-align: right; padding: 1em 0"
      >
        <button
          href=""
          @click="continueNext()"
          class="btn btn--filter btn--pink"
        >
          <span>Continue</span>
          <i class="fas fa-caret-right"></i>
        </button>
      </div>
      <!-- /.section__content -->
    </section>
    <!-- /.section-web -->
  </div>
  <!-- /.container container-/-large -->
</template>
<script>
import $ from "jquery";

export default {
  name: "LandingPage",
  data: function() {
    return {
      list: [],
    };
  },
  methods: {
    continueNext: function() {
      this.$router.push("/content/profile").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
    },
  },
  computed: {
    organization() {
      return this.$store.state.organizationInfo;
    },
    isMobile() {
      console.log("this.$store.getters.isMobile", this.$store.getters.isMobile);
      return this.$store.getters.isMobile;
    },
    isTablet() {
      console.log(
        "this.$store.getters.isTablet ",
        this.$store.getters.isTablet
      );
      return this.$store.getters.isTablet;
    },
  },
  async created() {
    window.scrollTo(0, 0);
    this.list = this.$store.state.organizationInfo;
    console.log("NEW PUSH 2022");
    await this.$store.dispatch("getPaymentMethods");
  },

  mounted() {
    this.list = this.$store.state.organizationInfo;
  },
};
</script>
<style scoped>
.section-web .section__content--grey {
  padding: 48px 30px 34px;
}
table {
  width: auto !important;
  border-collapse: collapse;
  border-spacing: 0;
}
.mobile-wrap {
  zoom: 50%;
}
</style>
